module.exports = __webpack_public_path__ + "static/media/7a_website_logo_Gold_fujitec.a63dfeea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/7a_website_logo_Gold_fujitec.jpg
// module id = 109
// module chunks = 0